import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import {
  GetPartCatalogDetails,
  getPartGroupAllList,
  getPartLocationAllList,
  getPartSideAllList,
  getPartTypeAllList,
} from "../../services/PartTypeService";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  createPartCatalog,
  deletePartCatalogAttribute,
  getEtaiSearchList,
  getLerCatalogList,
  getPartCatalogList,
  getPartCatalogViewList,
  updatePartCatalog,
} from "../../services/LerCatalogService";
import ConfigDB from "../../config";
import Pagination from "react-js-pagination";
import { useTranslation } from "react-i18next";
import { getSearchSubCategories } from "../../services/CategoriesServices";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";
import { getCommonSearchList } from "../../services/settingsServices";
import { getRoleList } from "../../services/UserServices";
import {
  deletePartCatalogCheckList,
  getCatalogPartsList,
} from "../../services/PartsInventory";
import ReactPaginate from "react-paginate";

const AddCatalog = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tableLengthList = ConfigDB.data.dataTableLength;

  const [partCatalogData, setPartCatalogData] = useState({
    id: "",
    namePartPT: "",
    namePartES: "",
    namePartEN: "",
    namePartFR: "",
    namePartIT: "",
    namePartDE: "",
    idTypePart: "",
    idLocation: "",
    idGroup: "",
    idSide: "",
    dependsBodyCar: "0",
    numCarDoors: "5",
    individual: "0",
    weight: "0",
    length: "0",
    width: "0",
    height: "0",
    is_master_part: "0",
    etai_part_id: "",
    vehicle_type_id: [],
    data_type_id: "",
    vehicle_check_list: [],
    urlImage: "",
    catalog_part_list: [],
  });

  let errorsObj = {
    namePartPT: "",
    namePartES: "",
    namePartEN: "",
    namePartFR: "",
    namePartIT: "",
    namePartDE: "",
    idTypePart: "",
    idLocation: "",
    idGroup: "",
    idSide: "",
    dependsBodyCar: "",
    numCarDoors: "",
    individual: "",
    weight: "",
    length: "",
    width: "",
    height: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [partTypeList, setPartTypeList] = useState([]);
  const [partLocationList, setPartLocationList] = useState([]);
  const [partGroupList, setPartGroupList] = useState([]);
  const [partSideList, setPartSideList] = useState([]);
  const [partCatalogDetails, setCatalogDetails] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [partList, setPartList] = useState([]);
  const [lerList, setLerList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRecordLer, setTotalRecordLer] = useState(0);
  const [addedParts, setAddedParts] = useState([]);
  const [addedLers, setAddedLers] = useState([]);
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    search: "",
    is_reload: false,
  });
  const [VehicleEngineList, setVehicleEngineList] = useState([]);
  const [inputSelctededEngineValue, setInputSelctedEngineValue] = useState("");
  const [weightUnits, setWeightUnits] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [selectedEntityId, setSelectedEntityId] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchCatalog, setSearchCatalog] = useState("");

  const [VehicleTypePartList, setVehicleTypePartList] = useState([]);
  const [partCatalogAttributeList, setPartCatalogAttributeList] = useState([]);
  const [attributeValues, setAttributeValues] = useState([]);
  const [attributeFields, setAttributeFields] = useState([]);
  const [roleList, setRolelList] = useState([]);
  const [openModalRestrict, setOpenModalRestrict] = useState(false);
  const [restrictIndex, setRestrictIndex] = useState("");
  const [restrictField, setRestrictField] = useState("");
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [delCheckModal, setDelCheckModal] = useState(false);
  const [isDelCheckButtonLoad, setIsDelCheckButtonLoad] = useState(false);
  const [delCheckpart, setDelCheckPart] = useState("");
  const [delOptionModal, setDelOptionModal] = useState(false);
  const [isDelOptionButtonLoad, setIsDelOptionButtonLoad] = useState(false);
  const [delOptionpart, setDelOptionPart] = useState("");
  const [catalogPartsList, setCatalogPartsList] = useState([]);
  const [totalRecordsCatelog, setTotalRecordsCatelog] = useState([]);
  const [addedCatalogParts, setAddedCatalogParts] = useState([]);
  const [catalogPage, setCatalogPage] = useState(1); // current page
  const [catalogLimit] = useState(tableLengthList[0]); // items per page
  const [lerPage, setLerPage] = useState(1); // current page
  const [lerLimit] = useState(tableLengthList[0]); // items per page
  const [partPage, setPartPage] = useState(1); // current page
  const [partLimit] = useState(tableLengthList[0]); // items per page

  const handleAddChecklistRow = () => {
    const incomplete = partCatalogData.vehicle_check_list?.some(
      (item) => !item.name.trim()
    );

    if (incomplete) {
      toast.error(t("pc_toast_name_required_checklist"));
      return;
    }

    setPartCatalogData((prev) => ({
      ...prev,
      vehicle_check_list: [
        ...(Array.isArray(prev.vehicle_check_list)
          ? prev.vehicle_check_list
          : []),
        {
          name: "",
          description: "",
          is_default: 0,
        },
      ],
    }));
  };

  const handleChecklistChange = (index, field, value) => {
    const updatedList = [...partCatalogData.vehicle_check_list];
    updatedList[index][field] = value;
    setPartCatalogData((prev) => ({
      ...prev,
      vehicle_check_list: updatedList,
    }));
  };

  const handleChecklistCheckbox = (index) => {
    const updatedList = [...partCatalogData.vehicle_check_list];
    updatedList[index].is_default = updatedList[index].is_default === 1 ? 0 : 1;
    setPartCatalogData((prev) => ({
      ...prev,
      vehicle_check_list: updatedList,
    }));
  };

  const handleDeleteChecklistRow = (index, item) => {
    if (item.id) {
      setDelCheckPart(item);
      setDelCheckModal(true);
    } else {
      const updatedList = partCatalogData.vehicle_check_list.filter(
        (_, i) => i !== index
      );
      setPartCatalogData((prev) => ({
        ...prev,
        vehicle_check_list: updatedList,
      }));
    }
  };

  const onRemoveCheckListRow = (e) => {
    e.preventDefault();
    setIsDelCheckButtonLoad(true);
    let data = { checklist_id: delCheckpart.id };
    deletePartCatalogCheckList(data)
      .then((response) => {
        toast.success(response.data.message);
        setDelCheckPart("");
        setDelCheckModal(false);
        setIsDelCheckButtonLoad(false);
        let data = {
          id: uuid,
        };
        GetPartCatalogDetails(data)
          .then((response) => {
            setCatalogDetails(response.data.data);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        setIsDelCheckButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onRemoveOptionRow = (e) => {
    e.preventDefault();
    setIsDelOptionButtonLoad(true);
    let data = { attribute_option_id: delOptionpart.id };
    deletePartCatalogAttribute(data)
      .then((response) => {
        toast.success(response.data.message);
        setDelOptionPart("");
        setDelOptionModal(false);
        setIsDelButtonLoad(false);
        let data = {
          id: uuid,
        };
        GetPartCatalogDetails(data)
          .then((response) => {
            setCatalogDetails(response.data.data);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleRestrictModalOpen = (index, field) => {
    setRestrictIndex(index);
    setRestrictField(field);

    setOpenModalRestrict(true);
  };

  const handleRestrictModalClose = () => {
    setOpenModalRestrict(false);
  };

  const handleAddAttributeField = () => {
    if (!partCatalogData.data_type_id) return;

    const selectedType = partCatalogAttributeList.find(
      (item) => item.value === partCatalogData.data_type_id
    );

    const data_type_name = selectedType?.label || "text";
    // const isDuplicate = attributeFields.some(
    //   (field) =>
    //     field.label_name?.trim().toLowerCase() === trimmedLabel &&
    //     field.data_type_id === partCatalogData.data_type_id
    // );

    // if (isDuplicate) {
    //   toast.error("Label name already exists for the selected data type.");
    //   return;
    // }

    const roleIdString = Array.isArray(partCatalogData.role_id)
      ? partCatalogData.role_id.join(",")
      : partCatalogData.role_id || "";

    setAttributeFields([
      ...(attributeFields || []),
      {
        data_type_id: partCatalogData.data_type_id,
        data_type_name,
        label_name: "",
        value: data_type_name === "checkbox" ? 0 : "",
        is_required: 0,
        is_multiple: 0,
        is_view: 0,
        is_edit: 0,
        // default_value para peças legacy sem entrada em
        // vehicle_parts_attributes — só checkbox usa por agora.
        default_value: data_type_name === "checkbox" ? "0" : "",
        role_id: roleIdString,
        attribute_options: [],
      },
    ]);
  };

  const handleAttributeValueChange = (index, key, value) => {
    const updated = [...attributeFields];
    updated[index][key] = value;
    setAttributeFields(updated);
  };

  const handleAddAttributeRow = (afterIndex) => {
    const baseRow = attributeFields[afterIndex];
    if (!baseRow.label_name?.trim()) {
      toast.error(t("pc_toast_label_name_required"));
      return;
    }

    if (baseRow.role_id === null || baseRow.role_id === "") {
      toast.error(t("pc_toast_role_id_required"));
      return;
    }

    if (baseRow.is_view !== 1 && baseRow.is_edit !== 1) {
      toast.error(
        "At least one of 'is view' or 'is edit' must be selected (set to 1)."
      );
      return;
    }

    if (baseRow.data_type_id === 2) {
      const hasValidOption =
        Array.isArray(baseRow.attribute_options) &&
        baseRow.attribute_options.some((opt) => opt.option_name?.trim());

      if (!hasValidOption) {
        toast.error(
          "At least one non-empty option is required for 'Selection' type."
        );
        return;
      }
    }

    const newRow = {
      data_type_id: baseRow.data_type_id,
      data_type_name: baseRow.data_type_name,
      label_name: "",
      is_required: 0,
      is_multiple: 0,
      is_view: 0,
      is_edit: 0,
      default_value: baseRow.data_type_name === "checkbox" ? "0" : "",
      role_id: [],
      value: "",
    };

    const updatedFields = [...attributeFields];
    updatedFields.splice(afterIndex + 1, 0, newRow);
    setAttributeFields(updatedFields);
  };

  const handleOptionChange = (fieldIndex, optIndex, newValue) => {
    const updatedFields = [...attributeFields];
    const field = updatedFields[fieldIndex];
    const trimmedValue = newValue.trim().toLowerCase();

    const isDuplicate = field.attribute_options.some(
      (opt, i) =>
        i !== optIndex && opt.option_name.trim().toLowerCase() === trimmedValue
    );

    if (isDuplicate) {
      toast.error(t("pc_toast_option_name_unique"));
      return;
    }

    field.attribute_options[optIndex].option_name = newValue;
    setAttributeFields(updatedFields);
  };

  const handleAddOption = (fieldIndex) => {
    const updatedFields = [...attributeFields];
    const field = updatedFields[fieldIndex];

    if (!field.attribute_options) {
      field.attribute_options = [];
    }

    const existingNames = field.attribute_options.map((opt) =>
      opt.option_name.trim().toLowerCase()
    );

    if (existingNames.includes("")) {
      toast.error(t("pc_toast_fill_existing_option_first"));
      return;
    }

    field.attribute_options.push({ option_name: "" });
    setAttributeFields(updatedFields);
  };

  const handleRemoveOption = (fieldIndex, optionIndex, option) => {
    if (option?.id) {
      setDelOptionPart(option);
      setDelOptionModal(true);
    } else {
      const updated = [...attributeFields];
      updated[fieldIndex].attribute_options.splice(optionIndex, 1);
      setAttributeFields(updated);
    }
  };

  const onDeleteCheckModalClose = () => {
    setDelCheckModal(false);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOptionClose = () => {
    setDelOptionModal(false);
  };

  const handleRemoveAttributeRow = (index, item) => {
    if (item?.id) {
      setDelPart(item);
      setDelModal(true);
    } else {
      const updatedFields = [...attributeFields];
      updatedFields.splice(index, 1);
      setAttributeFields(updatedFields);
    }
  };

  const onRemoveAttributeRow = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { attribute_id: delpart.id };
    deletePartCatalogAttribute(data)
      .then((response) => {
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
        let data = {
          id: uuid,
        };
        GetPartCatalogDetails(data)
          .then((response) => {
            setCatalogDetails(response.data.data);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedEntityId(value);

    const findSelected = (nodes) => {
      for (let node of nodes) {
        if (String(node.id) === String(value)) return node;
        if (node.children?.length) {
          const found = findSelected(node.children);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedItem = findSelected(categoryList);

    if (selectedItem) {
      const isAlreadyAdded = categoryData?.some(
        (item) => String(item.id) === String(selectedItem.id)
      );
      if (!isAlreadyAdded) {
        setCategoryData((prev = []) => [...prev, selectedItem]);
      } else {
        toast.error(`"${selectedItem.sub_category_name}" is already added.`);
      }
    }
  };

  const removeCategory = (id) => {
    setCategoryData((prev) => prev.filter((item) => item.id !== id));
  };

  useEffect(() => {
    getRoleList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setRolelList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      id: 0,
    };
    getSearchSubCategories(data)
      .then((response) => {
        setCategoryList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  const filteredPartAssignLerList = (lerList?.length ? lerList : [])?.filter(
    (item) => !addedLers?.some((addedLER) => addedLER.id === item.id)
  );

  useEffect(() => {
    const initialWeights = lerList.reduce((acc, item) => {
      acc[item.id] = item?.item_weight_unit || "";
      return acc;
    }, {});
    setWeightUnits(initialWeights);
  }, [lerList]);

  const handleChange = (e, id) => {
    setWeightUnits((prev) => ({
      ...prev,
      [id]: e.target.value,
    }));
  };

  const handlePageChange = (pageNumber) => {
    setParams((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  };

  const handlePageChangePart = (pageNumber) => {
    setParams((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  };

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypePartList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_catalog_attribute_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartCatalogAttributeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };
    getEtaiSearchList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].product_label,
          });
        }

        setVehicleEngineList(list);
      })
      .catch(() => {});
  }, []);

  const handleInputSelectedChangeEngineList = (inputSelctededEngineValue) => {
    setInputSelctedEngineValue(inputSelctededEngineValue);

    if (inputSelctededEngineValue.length > 0) {
      const obj = {
        search: inputSelctededEngineValue,
        limit: tableLengthList[0],
        page: 1,
      };

      getEtaiSearchList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].product_label,
            });
          }
          setVehicleEngineList(list);
        })
        .catch((err) => {});
    }
  };

  const { uuid } = useParams();

  useEffect(() => {
    let data = {
      id: uuid,
    };
    GetPartCatalogDetails(data)
      .then((response) => {
        setCatalogDetails(response.data.data);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (partCatalogDetails) {
      setPartCatalogData({
        id: partCatalogDetails?.id,
        namePartPT: partCatalogDetails?.namePartPT,
        namePartES: partCatalogDetails?.namePartES,
        namePartEN: partCatalogDetails?.namePartEN,
        namePartFR: partCatalogDetails?.namePartFR,
        namePartIT: partCatalogDetails?.namePartIT,
        namePartDE: partCatalogDetails?.namePartDE,
        idTypePart: partCatalogDetails?.idTypePart,
        idLocation: partCatalogDetails?.idLocation,
        idGroup: partCatalogDetails?.idGroup,
        idSide: partCatalogDetails?.idSide,
        dependsBodyCar: partCatalogDetails?.dependsBodyCar,
        numCarDoors: partCatalogDetails?.numCarDoors,
        individual: partCatalogDetails?.individual,
        weight: partCatalogDetails?.weight,
        length: partCatalogDetails?.length,
        width: partCatalogDetails?.width,
        height: partCatalogDetails?.height,
        etai_part_id: partCatalogDetails?.etai_part_id,
        is_master_part: partCatalogDetails?.is_master_part,
        part_list: partCatalogDetails?.part_list,
        vehicle_type_id: Array.isArray(
          partCatalogDetails?.catalog_vehicle_type_list
        )
          ? partCatalogDetails.catalog_vehicle_type_list.map((item) =>
              parseInt(item.vehicle_type_id)
            )
          : [],
        vehicle_check_list: partCatalogDetails?.catalog_check_list,
        urlImage: partCatalogDetails?.urlImage,
      });
      setAddedParts(partCatalogDetails?.part_list);
      setAddedLers(partCatalogDetails?.ler_catalog_list);
      setCategoryData(partCatalogDetails?.category_list);
      setAttributeFields(
        partCatalogDetails?.catalog_attribute_list?.map((item) => ({
          ...item,
          role_id: item.role_id
            ? item.role_id.split(",").map((id) => Number(id))
            : [],
        }))
      );
      setAddedCatalogParts(partCatalogDetails?.catalog_part_list);
    }
  }, [partCatalogDetails]);

  useEffect(function () {
    getPartTypeAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }

        setPartTypeList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartLocationAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartLocationList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartGroupAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartGroupList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartSideAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartSideList(list);
      })
      .catch(() => {});
  }, []);

  const handleCheckboxChange = (e) => {
    setPartCatalogData({
      ...partCatalogData,
      individual: e.target.checked ? "1" : "0",
    });
  };

  const handleCheckboxChangeMaster = (e) => {
    setPartCatalogData({
      ...partCatalogData,
      is_master_part: e.target.checked ? "1" : "0",
    });
  };

  const handleCheckboxChangeDependCar = (e) => {
    setPartCatalogData({
      ...partCatalogData,
      dependsBodyCar: e.target.checked ? "1" : "0",
    });
  };

  useEffect(() => {
    let data = {
      limit: partLimit,
      page: partPage,
      search: search ? search : "",
      is_reload: false,
    };
    getPartCatalogViewList(data)
      .then((response) => {
        setPartList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  }, [partLimit, partPage, search]);

  useEffect(() => {
    setPartPage(1);
  }, [search]);

  useEffect(() => {
    setCatalogPage(1);
  }, [searchCatalog]);

  useEffect(() => {
    const data = {
      limit: catalogLimit,
      page: catalogPage,
      search: searchCatalog ? searchCatalog : "",
      is_reload: false,
    };

    getCatalogPartsList(data)
      .then((res) => {
        setCatalogPartsList(res.data.data);
        setTotalRecordsCatelog(res.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  }, [catalogPage, searchCatalog, catalogLimit]);

  useEffect(() => {
    let data = {
      limit: lerLimit,
      page: lerPage,
      search: "",
      is_reload: false,
    };

    getLerCatalogList(data)
      .then((response) => {
        setLerList(response.data.data);
        setTotalRecordLer(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, [lerLimit, lerPage]);

  const handleAddClick = async (id, namePartPT) => {
    const isAdded = addedParts?.some((part) => part.id === id);

    if (isAdded) {
      try {
      } catch (error) {
        console.error(`Error deleting item with ID ${id}:`, error);
      }

      setAddedParts((prev = []) => prev.filter((part) => part?.id !== id));
    } else {
      setAddedParts((prev = []) => [...prev, { id, namePartPT }]);
    }
  };
  const filteredPartAssignList = (partList?.length ? partList : [])?.filter(
    (item) =>
      !addedParts?.some((addedPart) => addedPart.id === item.id) &&
      item.namePartPT !== partCatalogDetails?.namePartPT &&
      item.namePartES !== partCatalogDetails?.namePartES &&
      item.namePartEN !== partCatalogDetails?.namePartEN &&
      item.namePartFR !== partCatalogDetails?.namePartFR &&
      item.namePartIT !== partCatalogDetails?.namePartIT &&
      item.namePartDE !== partCatalogDetails?.namePartDE &&
      (item.is_master_part === "0" || item.is_master_part === null) &&
      (!search ||
        item.namePartPT?.toLowerCase().includes(search.toLowerCase()) ||
        item.namePartEN?.toLowerCase().includes(search.toLowerCase()) ||
        item.part_code?.toLowerCase().includes(search.toLowerCase()) ||
        item.part_description?.toLowerCase().includes(search.toLowerCase()))
  );

  const handleAddCatalogClick = async (id, name) => {
    const isAdded = addedCatalogParts?.some((part) => part.id === id);

    if (isAdded) {
      try {
      } catch (error) {
        console.error(`Error deleting item with ID ${id}:`, error);
      }

      setAddedCatalogParts((prev = []) =>
        prev.filter((part) => part?.id !== id)
      );
    } else {
      setAddedCatalogParts((prev = []) => [...prev, { id, name }]);
    }
  };
  const filteredPartAssignCatalogList = (
    catalogPartsList?.length ? catalogPartsList : []
  )?.filter(
    (item) =>
      !addedCatalogParts?.some((addedPart) => addedPart.id === item.id) &&
      (!searchCatalog ||
        item.name?.toLowerCase().includes(searchCatalog.toLowerCase()))
  );

  const handleAddClickLER = async (id, ler_name) => {
    const isAdded = addedLers?.some((ler) => ler.id === id);

    if (isAdded) {
      try {
        // Handle delete logic if required
      } catch (error) {
        console.error(`Error deleting item with ID ${id}:`, error);
      }

      setAddedLers((prev = []) => prev.filter((ler) => ler?.id !== id));
    } else {
      setAddedLers((prev = []) => [
        ...prev,
        {
          id,
          ler_name,
          item_weight_unit: weightUnits[id] || "", // Take the edited value
        },
      ]);
    }
  };

  const validateAttributeFields = () => {
    for (let i = 0; i < attributeFields?.length; i++) {
      const row = attributeFields[i];

      if (!row.label_name?.trim()) {
        toast.error(`Row ${i + 1}: Label name is required.`);
        setBtnLoader(false);

        return false;
      }

      // if (row.role_id === null || row.role_id === "") {
      //   toast.error(`Row ${i + 1}: Role ID is required.`);
      //   setBtnLoader(false);

      //   return false;
      // }

      // if (row.is_view !== 1 && row.is_edit !== 1) {
      //   toast.error(
      //     `Row ${
      //       i + 1
      //     }: At least one of 'is_view' or 'is_edit' must be selected.`
      //   );
      //   setBtnLoader(false);

      //   return false;
      // }

      if (row.data_type_id === 2) {
        const hasValidOption =
          Array.isArray(row.attribute_options) &&
          row.attribute_options.some((opt) => opt.option_name?.trim());

        if (!hasValidOption) {
          toast.error(
            `Row ${
              i + 1
            }: At least one non-empty option is required for 'Selection' type.`
          );
          setBtnLoader(false);

          return false;
        }
      }
    }
    return true;
  };

  const handlePartCatalogForm = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!partCatalogData.namePartPT) {
      errorObj.namePartPT = `Part PT required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!partCatalogData.namePartES) {
      errorObj.namePartES = `Part ES required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.namePartEN) {
      errorObj.namePartEN = `Part EN required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.namePartFR) {
      errorObj.namePartFR = `Part FR required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.namePartIT) {
      errorObj.namePartIT = `Part IT required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.namePartDE) {
      errorObj.namePartDE = `Part DE required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!partCatalogData.idTypePart) {
      errorObj.idTypePart = `Part Type required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.idLocation) {
      errorObj.idLocation = `Part Location required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.idGroup) {
      errorObj.idGroup = `Part Group required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!partCatalogData.idSide) {
      errorObj.idSide = `Part Slide required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!partCatalogData?.urlImage) {
      errorObj.urlImage = "URL is required.";
      error = true;
      setBtnLoader(false);
    } else {
      // Allow only image URLs
      const imageUrlPattern =
        /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif|webp|svg))$/i;

      if (!imageUrlPattern.test(partCatalogData.urlImage)) {
        errorObj.urlImage =
          "Please enter a valid image URL (jpg, jpeg, png, gif, webp, svg).";
        error = true;
        setBtnLoader(false);
      }
    }

    setErrors(errorObj);
    Utils.focusError();
    if (!validateAttributeFields()) return;

    if (error) return;

    const part_list = addedParts?.map((item) => ({ id: item.id })) || [];
    const ler_catalog_list = addedLers?.map((item) => ({
      id: item.id,
      unit_value: item?.item_weight_unit,
    }));
    const category_list = categoryData?.map((item) => ({
      id: item.id,
    }));

    const attribute_type_list = attributeFields?.map((item) => ({
      data_type_id: item?.data_type_id,
      label_name: item.label_name,
      is_required: item?.is_required,
      is_multiple: item?.is_multiple,
      // Só envia default_value quando a UI o expõe (checkbox). Em outros
      // tipos fica omisso → backend preserva o valor anterior na BD.
      ...(item?.data_type_id === 5
        ? {
            default_value:
              item?.default_value === "1" || item?.default_value === 1
                ? "1"
                : "0",
          }
        : {}),
      role_id: Array.isArray(item?.role_id)
        ? item.role_id.join(",")
        : item?.role_id || "",
      is_view: item?.is_view,
      is_edit: item?.is_edit,
      attribute_options: item?.attribute_options,
      id: item?.id ? item?.id : "",
    }));

    const vehicle_check_list = partCatalogData?.vehicle_check_list?.map(
      (item) => ({
        name: item?.name,
        description: item?.description,
        is_default: item?.is_default,
        id: item?.id ? item?.id : "",
      })
    );

    const catalog_part_list =
      addedCatalogParts?.map((item) => ({ id: item.id })) || [];

    let data = {
      namePartPT: partCatalogData?.namePartPT,
      namePartES: partCatalogData?.namePartES,
      namePartEN: partCatalogData?.namePartEN,
      namePartFR: partCatalogData?.namePartFR,
      namePartIT: partCatalogData?.namePartIT,
      namePartDE: partCatalogData?.namePartDE,
      idTypePart: partCatalogData?.idTypePart,
      idLocation: partCatalogData?.idLocation,
      idGroup: partCatalogData?.idGroup,
      idSide: partCatalogData?.idSide,
      dependsBodyCar: partCatalogData?.dependsBodyCar
        ? partCatalogData?.dependsBodyCar
        : "0",
      numCarDoors: partCatalogData?.numCarDoors || 5,
      individual: partCatalogData?.individual,
      weight: partCatalogData?.weight || 0,
      length: partCatalogData?.length || 0,
      width: partCatalogData?.width || 0,
      height: partCatalogData?.height || 0,
      etai_part_id: partCatalogData?.etai_part_id,
      part_list: part_list,
      is_master_part: partCatalogData?.is_master_part,
      ler_catalog_list: ler_catalog_list,
      category_list: category_list,
      vehicle_type_list: Array.isArray(partCatalogData.vehicle_type_id)
        ? partCatalogData.vehicle_type_id.map((id) => ({ id }))
        : [],
      attribute_type_list: attribute_type_list,
      vehicle_check_list: vehicle_check_list,
      urlImage: partCatalogData?.urlImage,
      catalog_part_list: catalog_part_list,
    };

    let updateData = {
      id: partCatalogData?.id,
      namePartPT: partCatalogData?.namePartPT,
      namePartES: partCatalogData?.namePartES,
      namePartEN: partCatalogData?.namePartEN,
      namePartFR: partCatalogData?.namePartFR,
      namePartIT: partCatalogData?.namePartIT,
      namePartDE: partCatalogData?.namePartDE,
      idTypePart: partCatalogData?.idTypePart,
      idLocation: partCatalogData?.idLocation,
      idGroup: partCatalogData?.idGroup,
      idSide: partCatalogData?.idSide,
      dependsBodyCar: partCatalogData?.dependsBodyCar,
      numCarDoors: partCatalogData?.numCarDoors,
      individual: partCatalogData?.individual,
      weight: partCatalogData?.weight,
      length: partCatalogData?.length,
      width: partCatalogData?.width,
      height: partCatalogData?.height,
      etai_part_id: partCatalogData?.etai_part_id,
      part_list: part_list,
      is_master_part: partCatalogData?.is_master_part,
      ler_catalog_list: ler_catalog_list,
      category_list: category_list,
      vehicle_type_list: Array.isArray(partCatalogData.vehicle_type_id)
        ? partCatalogData.vehicle_type_id.map((id) => ({ id }))
        : [],
      attribute_type_list: attribute_type_list,
      vehicle_check_list: vehicle_check_list,
      urlImage: partCatalogData?.urlImage,
      catalog_part_list: catalog_part_list,
    };

    if (partCatalogData?.id) {
      updatePartCatalog(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/part-catalog");

          setPartCatalogData({
            id: "",
            namePartPT: "",
            namePartES: "",
            namePartEN: "",
            namePartFR: "",
            namePartIT: "",
            namePartDE: "",
            idTypePart: "",
            idLocation: "",
            idGroup: "",
            idSide: "",
            dependsBodyCar: "0",
            numCarDoors: "5",
            individual: "0",
            weight: "0",
            length: "0",
            width: "0",
            height: "0",
            is_master_part: "0",
            etai_part_id: "",
            vehicle_type_id: [],
            vehicle_check_list: [],
            urlImage: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createPartCatalog(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/part-catalog");
          setPartCatalogData({
            id: "",
            namePartPT: "",
            namePartES: "",
            namePartEN: "",
            namePartFR: "",
            namePartIT: "",
            namePartDE: "",
            idTypePart: "",
            idLocation: "",
            idGroup: "",
            idSide: "",
            dependsBodyCar: "0",
            numCarDoors: "5",
            individual: "0",
            weight: "0",
            length: "0",
            width: "0",
            height: "0",
            is_master_part: "0",
            etai_part_id: "",
            vehicle_type_id: [],
            vehicle_check_list: [],
            urlImage: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => (
      <React.Fragment key={node.id}>
        <option
          value={node.id}
          style={{ fontWeight: node.children?.length ? "bold" : "normal" }}
        >
          {"\u00A0\u00A0".repeat(level) + node.sub_category_name}
        </option>
        {node.children?.length > 0 && renderOptions(node.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>{t("add_catalog")}</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/part-catalog">{t("part_catalog")}</a>
                </li>
                <li className="breadcrumb-item active">
                  {t("add_partCatalog")}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}PT
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartPT}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartPT: e.target.value,
                                });
                              }}
                              name={`namePartPT`}
                              maxLength={100}
                              placeholder={t("pc_part_pt")}
                            />
                          </div>
                          {errors.namePartPT && (
                            <span className="input-error">
                              {errors.namePartPT}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}ES
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartES}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartES: e.target.value,
                                });
                              }}
                              name={`namePartES`}
                              maxLength={100}
                              placeholder={t("pc_part_es")}
                            />
                          </div>
                          {errors.namePartES && (
                            <span className="input-error">
                              {errors.namePartES}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}UK
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartEN}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartEN: e.target.value,
                                });
                              }}
                              name={`namePartEN`}
                              maxLength={100}
                              placeholder={t("pc_part_uk")}
                            />
                          </div>
                          {errors.namePartEN && (
                            <span className="input-error">
                              {errors.namePartEN}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}FR
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartFR}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartFR: e.target.value,
                                });
                              }}
                              name={`namePartFR`}
                              maxLength={100}
                              placeholder={t("pc_part_fr")}
                            />
                          </div>
                          {errors.namePartFR && (
                            <span className="input-error">
                              {errors.namePartFR}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}IT
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartIT}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartIT: e.target.value,
                                });
                              }}
                              name={`namePartIT`}
                              maxLength={100}
                              placeholder={t("pc_part_it")}
                            />
                          </div>
                          {errors.namePartIT && (
                            <span className="input-error">
                              {errors.namePartIT}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part")}DE
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.namePartDE}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  namePartDE: e.target.value,
                                });
                              }}
                              name={`namePartDE`}
                              maxLength={100}
                              placeholder={t("pc_part_de")}
                            />
                          </div>
                          {errors.namePartDE && (
                            <span className="input-error">
                              {errors.namePartDE}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part_type")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-Select"
                              options={partTypeList}
                              value={partTypeList.find(
                                (option) =>
                                  option.value ===
                                  Number(partCatalogData.idTypePart)
                              )}
                              onChange={(selectedOption) =>
                                setPartCatalogData({
                                  ...partCatalogData,
                                  idTypePart: selectedOption.value,
                                })
                              }
                              placeholder={"Select Part Type"}
                            />
                          </div>
                          {errors.idTypePart && (
                            <span className="input-error">
                              {errors.idTypePart}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part_location")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-Select"
                              options={partLocationList}
                              value={partLocationList.find(
                                (option) =>
                                  option.value ===
                                  Number(partCatalogData.idLocation)
                              )}
                              onChange={(selectedOption) =>
                                setPartCatalogData({
                                  ...partCatalogData,
                                  idLocation: selectedOption.value,
                                })
                              }
                              placeholder={"Select Part Location"}
                            />
                          </div>
                          {errors.idLocation && (
                            <span className="input-error">
                              {errors.idLocation}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part_group")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-Select"
                              options={partGroupList}
                              value={partGroupList.find(
                                (option) =>
                                  option.value ===
                                  Number(partCatalogData.idGroup)
                              )}
                              onChange={(selectedOption) =>
                                setPartCatalogData({
                                  ...partCatalogData,
                                  idGroup: selectedOption.value,
                                })
                              }
                              placeholder={"Select Part Group"}
                            />
                          </div>
                          {errors.idGroup && (
                            <span className="input-error">
                              {errors.idGroup}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("part_slide")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-Select"
                              options={partSideList}
                              value={partSideList.find(
                                (option) =>
                                  option.value ===
                                  Number(partCatalogData.idSide)
                              )}
                              onChange={(selectedOption) =>
                                setPartCatalogData({
                                  ...partCatalogData,
                                  idSide: selectedOption.value,
                                })
                              }
                              placeholder={"Select Part Slide"}
                            />
                          </div>
                          {errors.idSide && (
                            <span className="input-error">{errors.idSide}</span>
                          )}
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("Number Of Car Doors")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="number"
                              value={partCatalogData.numCarDoors}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  numCarDoors: e.target.value,
                                });
                              }}
                              name={`numCarDoors`}
                              maxLength={100}
                              placeholder={t("pc_number_of_car_doors")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("height")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="number"
                              value={partCatalogData.height}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  height: e.target.value,
                                });
                              }}
                              name={`height`}
                              maxLength={100}
                              placeholder="height"
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("weight")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="number"
                              value={partCatalogData.weight}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  weight: e.target.value,
                                });
                              }}
                              name={`weight`}
                              maxLength={100}
                              placeholder={t("weight")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("length")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="number"
                              value={partCatalogData.length}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  length: e.target.value,
                                });
                              }}
                              name={`length`}
                              maxLength={100}
                              placeholder={t("length")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("width")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control form-control input-search form-control"
                              type="number"
                              value={partCatalogData.width}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  width: e.target.value,
                                });
                              }}
                              name={`width`}
                              maxLength={100}
                              placeholder={t("width")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3 d-none">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_etai")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleEngineList}
                              value={VehicleEngineList.find(
                                (item) =>
                                  item.value === partCatalogData.etai_part_id
                              )}
                              onChange={(selectedOption) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  etai_part_id: selectedOption
                                    ? selectedOption.value
                                    : "",
                                });
                              }}
                              isSearchable={true}
                              onInputChange={
                                handleInputSelectedChangeEngineList
                              }
                              inputSelctedValue={inputSelctededEngineValue}
                              placeholder={"Select ETAI"}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("Individual")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={partCatalogData.individual === "1"}
                                onChange={handleCheckboxChange}
                              />
                              <label className="form-check-label">
                                Individual
                              </label>
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("depends_body_car")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={partCatalogData.dependsBodyCar === "1"}
                                onChange={handleCheckboxChangeDependCar}
                              />
                              <label className="form-check-label">
                                {t("depends_body_car")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("is_master_part")}{" "}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={partCatalogData.is_master_part === "1"}
                                onChange={handleCheckboxChangeMaster}
                              />
                              <label className="form-check-label pl-2">
                                {t("is_master_part")}{" "}
                              </label>
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          Vehicle Type
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleTypePartList}
                              value={VehicleTypePartList.filter((item) =>
                                partCatalogData.vehicle_type_id?.includes(
                                  item.value
                                )
                              )}
                              onChange={(selectedOptions) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  vehicle_type_id: selectedOptions
                                    ? selectedOptions.map((opt) => opt.value)
                                    : [],
                                });
                              }}
                              isSearchable={true}
                              isClearable={true}
                              isMulti={true}
                              placeholder="All"
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("url")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={partCatalogData.urlImage}
                              onChange={(e) => {
                                setPartCatalogData({
                                  ...partCatalogData,
                                  urlImage: e.target.value,
                                });
                              }}
                              name={`urlImage`}
                              placeholder="URL"
                            />
                            {errors.urlImage && (
                              <span className="input-error">
                                {errors.urlImage}
                              </span>
                            )}
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                  </div>

                  {partCatalogData.is_master_part === "1" && (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="vehicleThBg table-responsive min-height-0 pb-2">
                            <div
                              className="card-title m-0 float-left"
                              style={{ width: "50%" }}
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder={t("pc_search_part_name")}
                                style={{ marginBottom: "10px" }}
                              />
                            </div>

                            <table className="rounded-table table table-striped table-bordered table-hover">
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>
                                    {t("part_name")}
                                  </th>
                                  <th style={{ width: "10%" }}>
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {filteredPartAssignList?.length > 0 ? (
                                  filteredPartAssignList?.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item?.namePartPT}</td>

                                      <td>
                                        <Button
                                          className="addBtn"
                                          onClick={() =>
                                            handleAddClick(
                                              item.id,
                                              item.namePartPT
                                            )
                                          }
                                          style={{
                                            backgroundColor: addedParts?.some(
                                              (part) => part?.id === item?.id
                                            )
                                              ? "red"
                                              : "green",
                                            color: "white",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <i className="bi bi-plus-lg"></i>{" "}
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr className="scrollBrdr">
                                    <td colSpan="100%">
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="card-footer clearfix card-footer-part">
                            <div className="pagination pagination-sm m-0  paginationRight">
                              <ReactPaginate
                                previousLabel={
                                  <i className="bi bi-chevron-double-left"></i>
                                }
                                nextLabel={
                                  <i className="bi bi-chevron-double-right"></i>
                                }
                                breakLabel={"..."}
                                pageCount={Math.ceil(totalRecords / partLimit)}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={(e) =>
                                  setPartPage(e.selected + 1)
                                } // 0-based index
                                forcePage={partPage - 1} // keep UI synced
                                containerClassName={"pagination"}
                                activeClassName={"active"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6" style={{ marginTop: "57px" }}>
                          <div className="vehicleThBg table-responsive min-height-0 pb-2">
                            <table className="rounded-table table table-striped table-bordered table-hover">
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>
                                    {t("part_name")}
                                  </th>

                                  <th style={{ width: "0%" }}>{t("action")}</th>
                                </tr>
                              </thead>

                              <tbody>
                                {addedParts?.length > 0 ? (
                                  addedParts?.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item?.namePartPT}</td>

                                      <td className="">
                                        <button
                                          className="btn-danger-delete"
                                          href="#"
                                          onClick={() =>
                                            handleAddClick(
                                              item.id,
                                              item.namePartPT
                                            )
                                          }
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr className="scrollBrdr">
                                    <td colSpan="100%">
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      <div className="vehicleThBg table-responsive">
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>{t("ler_name")}</th>
                              <th style={{ width: "10%" }}>
                                {t("unit_value")}
                              </th>

                              <th style={{ width: "10%" }}>{t("action")}</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredPartAssignLerList?.length > 0 ? (
                              filteredPartAssignLerList?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.ler_name}</td>
                                  <td>
                                    <input
                                      type="text"
                                      value={weightUnits[item.id] || ""}
                                      onChange={(e) => handleChange(e, item.id)}
                                      className="form-control"
                                    />
                                  </td>

                                  <td>
                                    <Button
                                      className="addBtn"
                                      onClick={() =>
                                        handleAddClickLER(
                                          item.id,
                                          item.ler_name,
                                          item?.item_weight_unit
                                        )
                                      }
                                      style={{
                                        backgroundColor: addedParts?.some(
                                          (part) => part?.id === item?.id
                                        )
                                          ? "red"
                                          : "green",
                                        color: "white",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <i className="bi bi-plus-lg"></i>{" "}
                                    </Button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">{t("no_record_found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer clearfix card-footer-part">
                        <div className="pagination pagination-sm m-0  paginationRight">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecordLer / lerLimit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => setLerPage(e.selected + 1)} // 0-based index
                            forcePage={lerPage - 1} // keep UI synced
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="vehicleThBg table-responsive">
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>{t("ler_name")}</th>
                              <th style={{ width: "10%" }}>
                                {t("unit_value")}
                              </th>

                              <th style={{ width: "0%" }}>{t("action")}</th>
                            </tr>
                          </thead>

                          <tbody>
                            {addedLers?.length > 0 ? (
                              addedLers?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.ler_name}</td>

                                  <td>{item?.item_weight_unit}</td>

                                  <td className="">
                                    <button
                                      className="btn-danger-delete"
                                      href="#"
                                      onClick={() =>
                                        handleAddClickLER(
                                          item.id,
                                          item.ler_name,
                                          item?.item_weight_unit
                                        )
                                      }
                                    >
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">{t("no_record_found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6">
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("partsCatalogList")}
                      </Label>
                      <div className="vehicleThBg table-responsive min-height-0 pb-2">
                        <div
                          className="card-title m-0 float-left"
                          style={{ width: "50%" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            value={searchCatalog}
                            onChange={(e) => setSearchCatalog(e.target.value)}
                            placeholder={t("pc_search_part_catalog_name")}
                            style={{ marginBottom: "10px" }}
                          />
                        </div>

                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>{t("name")}</th>
                              <th style={{ width: "10%" }}>{t("action")}</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredPartAssignCatalogList?.length > 0 ? (
                              filteredPartAssignCatalogList?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{item?.name}</td>

                                    <td>
                                      <Button
                                        className="addBtn"
                                        type="button"
                                        onClick={() =>
                                          handleAddCatalogClick(
                                            item.id,
                                            item.name
                                          )
                                        }
                                        style={{
                                          backgroundColor:
                                            addedCatalogParts?.some(
                                              (part) => part?.id === item?.id
                                            )
                                              ? "red"
                                              : "green",
                                          color: "white",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <i className="bi bi-plus-lg"></i>{" "}
                                      </Button>
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">{t("no_record_found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer clearfix card-footer-part">
                        <div className="pagination pagination-sm m-0  paginationRight">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(
                              totalRecordsCatelog / catalogLimit
                            )}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => setCatalogPage(e.selected + 1)} // 0-based index
                            forcePage={catalogPage - 1} // keep UI synced
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: "100px" }}>
                      <div className="vehicleThBg table-responsive min-height-0 pb-2">
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>{t("name")}</th>
                              <th style={{ width: "0%" }}>{t("action")}</th>
                            </tr>
                          </thead>

                          <tbody>
                            {addedCatalogParts?.length > 0 ? (
                              addedCatalogParts?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.name}</td>

                                  <td className="">
                                    <button
                                      className="btn-danger-delete"
                                      type="button"
                                      onClick={() =>
                                        handleAddCatalogClick(
                                          item.id,
                                          item.name
                                        )
                                      }
                                    >
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">{t("no_record_found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          Category List
                        </Label>
                        <select
                          className="form-select"
                          value={selectedEntityId}
                          onChange={handleSelectChange}
                        >
                          <option>Select</option>
                          {renderOptions(categoryList)}
                        </select>
                      </FormGroup>
                    </div>

                    <div className="col-md-6">
                      <div className="vehicleThBg table-responsive">
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>Category Name</th>

                              <th style={{ width: "0%" }}>{t("action")}</th>
                            </tr>
                          </thead>

                          <tbody>
                            {categoryData?.length > 0 ? (
                              categoryData?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.sub_category_name}</td>

                                  <td className="">
                                    <button
                                      className="btn-danger-delete"
                                      type="button"
                                      onClick={() => removeCategory(item.id)}
                                    >
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">{t("no_record_found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-md-12"
                      style={{
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={handleAddChecklistRow}
                        type="button"
                      >
                        + Add Vehicle Check
                      </button>
                    </div>
                  </div>

                  {partCatalogData?.vehicle_check_list?.length > 0 ? (
                    <div
                      className="row justify-content-start"
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >
                      {partCatalogData.vehicle_check_list.map((item, index) => (
                        <div className="col-md-6">
                          <div className="fileupload-content px-4">
                            <div
                              className="row justify-content-start align-items-center mb-2"
                              key={index}
                            >
                              <div className="col-md-8">
                                <FormGroup>
                                  <Label className="col-form-label">Name</Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={item.name}
                                    onChange={(e) =>
                                      handleChecklistChange(
                                        index,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    placeholder={t("name")}
                                  />
                                </FormGroup>
                              </div>
                              <div className="col-md-4 d-flex align-items-center">
                                <FormGroup check>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={item.is_default === 1}
                                    onChange={() =>
                                      handleChecklistCheckbox(index)
                                    }
                                  />
                                  <Label className="form-check-label pl-2">
                                    Is Default
                                  </Label>
                                </FormGroup>
                                <button
                                  className="btn btn-danger trash-btn-custom btn-sm"
                                  onClick={() =>
                                    handleDeleteChecklistRow(index, item)
                                  }
                                  type="button"
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Description
                                  </Label>
                                  <textarea
                                    className="form-control"
                                    type="text"
                                    value={item.description}
                                    onChange={(e) =>
                                      handleChecklistChange(
                                        index,
                                        "description",
                                        e.target.value
                                      )
                                    }
                                    placeholder={t("description")}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No vehicle check list added.</p>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("attribute")}
                        </Label>
                        <div className="col-xl-12">
                          <Select
                            className="my-Select"
                            options={partCatalogAttributeList}
                            value={partCatalogAttributeList.find(
                              (option) =>
                                option.value ===
                                Number(partCatalogData.data_type_id)
                            )}
                            onChange={(selectedOption) => {
                              setPartCatalogData({
                                ...partCatalogData,
                                data_type_id: selectedOption.value,
                              });
                              setAttributeValues([]); // reset fields on type change
                            }}
                            placeholder={"Select Attribute"}
                          />
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-6" style={{ marginTop: "45px" }}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleAddAttributeField}
                      >
                        <i className="bi bi-plus-lg"></i>
                      </button>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="row justify-content-start align-items-center">
                        {attributeFields?.length > 0 &&
                          attributeFields?.map((field, index) => {
                            switch (field.data_type_name) {
                              case "Text":
                                return (
                                  <>
                                    <div className="col-md-6">
                                      <div className="card fuelCard">
                                        <div className="cardHeader card-header card-header-custom">
                                          Text
                                        </div>
                                        <div
                                          className="row-add-catalog"
                                          style={{
                                            marginTop: "10px",
                                          }}
                                        >
                                          <div className="row justify-content-start align-items-center">
                                            <div className="col" key={index}>
                                              <FormGroup>
                                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                  {t("Label")}
                                                </Label>
                                                <div className="col-xl-12">
                                                  <div className="input-div">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder={t("pc_label_name_placeholder")}
                                                      value={field.label_name}
                                                      onChange={(e) =>
                                                        handleAttributeValueChange(
                                                          index,
                                                          "label_name",
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </FormGroup>
                                            </div>

                                            {attributeFields.filter(
                                              (f) =>
                                                f.data_type_id ===
                                                field.data_type_id
                                            ) && (
                                              <>
                                                <div
                                                  className="col"
                                                  key={index}
                                                >
                                                  <FormGroup>
                                                    <Label
                                                      for=""
                                                      className="col-form-label ml-2 Label-my form-label"
                                                    >
                                                      {t("is_required")}
                                                    </Label>
                                                    <div className="col-xl-12">
                                                      <div className="input-div">
                                                        <div className="form-check">
                                                          <input
                                                            type="checkbox"
                                                            className="my-checkbox-1 form-check-input"
                                                            checked={
                                                              field.is_required
                                                            }
                                                            onChange={(e) =>
                                                              handleAttributeValueChange(
                                                                index,
                                                                "is_required",
                                                                e.target.checked
                                                                  ? 1
                                                                  : 0
                                                              )
                                                            }
                                                          />
                                                          <label className="form-check-label pl-2">
                                                            {t("is_required")}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </FormGroup>
                                                </div>

                                                <div className="col">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label">
                                                      {t("is_multiple")}
                                                    </Label>
                                                    <div className="col-xl-12">
                                                      <div className="input-div">
                                                        <div className="form-check">
                                                          <input
                                                            className="my-checkbox-1 form-check-input"
                                                            type="checkbox"
                                                            checked={
                                                              field.is_multiple
                                                            }
                                                            onChange={(e) =>
                                                              handleAttributeValueChange(
                                                                index,
                                                                "is_multiple",
                                                                e.target.checked
                                                                  ? 1
                                                                  : 0
                                                              )
                                                            }
                                                          />
                                                          <label className="form-check-label pl-2">
                                                            {t("is_multiple")}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </FormGroup>
                                                </div>
                                              </>
                                            )}
                                            <div className="col-md-4">
                                              <div className="bd-row">
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleRestrictModalOpen(
                                                      index,
                                                      field
                                                    )
                                                  }
                                                >
                                                  {t("restriction")}{" "}
                                                  <i className="bi bi-plus-lg"></i>
                                                </button>

                                                {attributeFields.findIndex(
                                                  (f) =>
                                                    f.data_type_id ===
                                                    field.data_type_id
                                                ) === index && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-success mr-2"
                                                    onClick={() =>
                                                      handleAddAttributeRow(
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-plus-lg"></i>
                                                  </button>
                                                )}
                                                <button
                                                  type="button"
                                                  className="btn btn-danger position-relative"
                                                  onClick={() =>
                                                    handleRemoveAttributeRow(
                                                      index,
                                                      field
                                                    )
                                                  }
                                                >
                                                  <i className="bi bi-trash3"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              case "Selection":
                                return (
                                  <div className="col-md-6">
                                    <div className="card fuelCard">
                                      <div className="cardHeader card-header card-header-custom">
                                        Selection
                                      </div>
                                      <div
                                        className="row-add-catalog"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div
                                          className="row justify-content-start align-items-center"
                                          key={index}
                                        >
                                          <div className="col">
                                            <FormGroup>
                                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                {t("Label")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("pc_label_name_placeholder")}
                                                    value={field.label_name}
                                                    onChange={(e) =>
                                                      handleAttributeValueChange(
                                                        index,
                                                        "label_name",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          {attributeFields.filter(
                                            (f) =>
                                              f.data_type_id ===
                                              field.data_type_id
                                          ) && (
                                            <>
                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_required")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_required
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_required",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_required")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_multiple")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_multiple
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_multiple",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_multiple")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-5">
                                            <div className="bd-row">
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleRestrictModalOpen(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                {t("restriction")}{" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>

                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleAddOption(index)
                                                }
                                              >
                                                {" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>
                                              {attributeFields.findIndex(
                                                (f) =>
                                                  f.data_type_id ===
                                                  field.data_type_id
                                              ) === index && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleAddAttributeRow(index)
                                                  }
                                                >
                                                  <i className="bi bi-tag"></i>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                className="btn btn-danger position-relative"
                                                onClick={() =>
                                                  handleRemoveAttributeRow(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </div>
                                          {/* Options List */}
                                          {field.attribute_options &&
                                            field.attribute_options.length >
                                              0 && (
                                              <div className="col-md-12">
                                                <div
                                                  style={{
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    border: "1px solid #dee2e6",
                                                    padding: "10px",
                                                    borderRadius: "6px",
                                                    backgroundColor: "#f8f9fa",
                                                    marginTop: "10px",
                                                    display: "grid",
                                                    gap: "8px",
                                                  }}
                                                >
                                                  {field.attribute_options.map(
                                                    (option, optIndex) => (
                                                      <div
                                                        key={optIndex}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "6px",
                                                        }}
                                                      >
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm"
                                                          placeholder={`Option ${
                                                            optIndex + 1
                                                          }`}
                                                          value={
                                                            option.option_name
                                                          }
                                                          onChange={(e) =>
                                                            handleOptionChange(
                                                              index,
                                                              optIndex,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                        <button
                                                          type="button"
                                                          className="btn btn-danger btn-sm"
                                                          onClick={() =>
                                                            handleRemoveOption(
                                                              index,
                                                              optIndex,
                                                              option
                                                            )
                                                          }
                                                        >
                                                          <i className="bi bi-trash"></i>
                                                        </button>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              case "Integer":
                                return (
                                  <div className="col-md-6">
                                    <div className="card fuelCard">
                                      <div className="cardHeader card-header card-header-custom">
                                        Integer
                                      </div>
                                      <div
                                        className="row-add-catalog"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div
                                          className="row justify-content-start align-items-center"
                                          key={index}
                                        >
                                          <div className="col">
                                            <FormGroup>
                                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                {t("Label")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("pc_label_name_placeholder")}
                                                    value={field.label_name}
                                                    onChange={(e) => {
                                                      const value =
                                                        e.target.value;

                                                      handleAttributeValueChange(
                                                        index,
                                                        "label_name",
                                                        value
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          {attributeFields.filter(
                                            (f) =>
                                              f.data_type_id ===
                                              field.data_type_id
                                          ) && (
                                            <>
                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_required")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_required
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_required",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_required")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_multiple")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_multiple
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_multiple",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_multiple")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-4">
                                            <div className="bd-row">
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleRestrictModalOpen(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                {t("restriction")}{" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>

                                              {attributeFields.findIndex(
                                                (f) =>
                                                  f.data_type_id ===
                                                  field.data_type_id
                                              ) === index && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleAddAttributeRow(index)
                                                  }
                                                >
                                                  <i className="bi bi-plus-lg"></i>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                className="btn btn-danger position-relative"
                                                onClick={() =>
                                                  handleRemoveAttributeRow(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              case "Float":
                                return (
                                  <div className="col-md-6">
                                    <div className="card fuelCard">
                                      <div className="cardHeader card-header card-header-custom">
                                        Float
                                      </div>
                                      <div
                                        className="row-add-catalog"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div
                                          className="row justify-content-start align-items-center"
                                          key={index}
                                        >
                                          <div className="col" key={index}>
                                            <FormGroup>
                                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                {t("Label")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("pc_label_name_placeholder")}
                                                    value={field.label_name}
                                                    onChange={(e) => {
                                                      const value =
                                                        e.target.value;

                                                      handleAttributeValueChange(
                                                        index,
                                                        "label_name",
                                                        value
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          {attributeFields.filter(
                                            (f) =>
                                              f.data_type_id ===
                                              field.data_type_id
                                          ) && (
                                            <>
                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_required")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_required
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_required",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_required")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_multiple")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_multiple
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_multiple",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_multiple")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-4">
                                            <div className="bd-row">
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleRestrictModalOpen(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                {t("restriction")}{" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>
                                              {attributeFields.findIndex(
                                                (f) =>
                                                  f.data_type_id ===
                                                  field.data_type_id
                                              ) === index && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleAddAttributeRow(index)
                                                  }
                                                >
                                                  <i className="bi bi-plus-lg"></i>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                className="btn btn-danger position-relative"
                                                onClick={() =>
                                                  handleRemoveAttributeRow(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              case "Checkbox":
                                return (
                                  <div className="col-md-6">
                                    <div className="card fuelCard">
                                      <div className="cardHeader card-header card-header-custom">
                                        Checkbox
                                      </div>
                                      <div
                                        className="row-add-catalog"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div
                                          className="row justify-content-start align-items-center"
                                          key={index}
                                        >
                                          <div className="col">
                                            <FormGroup>
                                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                {t("Label")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("pc_label_name_placeholder")}
                                                    value={field.label_name}
                                                    onChange={(e) =>
                                                      handleAttributeValueChange(
                                                        index,
                                                        "label_name",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          {attributeFields.filter(
                                            (f) =>
                                              f.data_type_id ===
                                              field.data_type_id
                                          ) && (
                                            <>
                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_required")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_required
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_required",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_required")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_multiple")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_multiple
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_multiple",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_multiple")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("default_checked")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.default_value === "1" ||
                                                            field.default_value === 1
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "default_value",
                                                              e.target.checked
                                                                ? "1"
                                                                : "0"
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("default_checked")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-4">
                                            <div className="bd-row">
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleRestrictModalOpen(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                {t("restriction")}{" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>
                                              {attributeFields.findIndex(
                                                (f) =>
                                                  f.data_type_id ===
                                                  field.data_type_id
                                              ) === index && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleAddAttributeRow(index)
                                                  }
                                                >
                                                  <i className="bi bi-plus-lg"></i>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                className="btn btn-danger position-relative"
                                                onClick={() =>
                                                  handleRemoveAttributeRow(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              case "Date":
                                return (
                                  <div className="col-md-6">
                                    <div className="card fuelCard">
                                      <div className="cardHeader card-header card-header-custom">
                                        Date
                                      </div>
                                      <div
                                        className="row-add-catalog"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div
                                          className="row justify-content-start align-items-center"
                                          key={index}
                                        >
                                          <div className="col">
                                            <FormGroup>
                                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                {t("label")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("pc_label_name_placeholder")}
                                                    value={field.label_name}
                                                    onChange={(e) =>
                                                      handleAttributeValueChange(
                                                        index,
                                                        "label_name",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          {attributeFields.filter(
                                            (f) =>
                                              f.data_type_id ===
                                              field.data_type_id
                                          ) && (
                                            <>
                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_required")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_required
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_required",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_required")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="col">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("is_multiple")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          type="checkbox"
                                                          className="my-checkbox-1 form-check-input"
                                                          checked={
                                                            field.is_multiple
                                                          }
                                                          onChange={(e) =>
                                                            handleAttributeValueChange(
                                                              index,
                                                              "is_multiple",
                                                              e.target.checked
                                                                ? 1
                                                                : 0
                                                            )
                                                          }
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("is_multiple")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-4">
                                            <div className="bd-row">
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={() =>
                                                  handleRestrictModalOpen(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                {t("restriction")}{" "}
                                                <i className="bi bi-plus-lg"></i>
                                              </button>

                                              {attributeFields.findIndex(
                                                (f) =>
                                                  f.data_type_id ===
                                                  field.data_type_id
                                              ) === index && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success mr-2"
                                                  onClick={() =>
                                                    handleAddAttributeRow(index)
                                                  }
                                                >
                                                  <i className="bi bi-plus-lg"></i>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                className="btn btn-danger position-relative"
                                                onClick={() =>
                                                  handleRemoveAttributeRow(
                                                    index,
                                                    field
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              default:
                                return null;
                            }
                          })}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col ms-2">
                      <button
                        type="button"
                        className="back-btn"
                        onClick={() => navigate("/part-catalog")}
                      >
                        <i className="bi bi-arrow-left"> </i> {t("back")}
                      </button>
                    </div>
                    <div className="col">
                      <div className="d-flex justify-content-end nxt-btn">
                        {btnLoader === true ? (
                          <button type="button" className="btn btn-primary">
                            Loading...
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={handlePartCatalogForm}
                            className="btn btn-primary"
                          >
                            {t("submit")} <i className="bi bi-check2"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer"></div>
              </div>
            </div>
          </div>

          <Modal isOpen={openModalRestrict}>
            <Form method={`post`} onSubmit={handleRestrictModalClose}>
              <ModalHeader>{t("restriction")}</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("role")}
                      </Label>
                      <div className="col-xl-12">
                        <Select
                          className="my-Select"
                          options={roleList}
                          isMulti // <-- Enables multiple select
                          value={roleList.filter((r) =>
                            Array.isArray(restrictField.role_id)
                              ? restrictField.role_id.includes(
                                  typeof r.value === "string"
                                    ? String(r.value)
                                    : Number(r.value)
                                )
                              : false
                          )}
                          onChange={(selectedOptions) =>
                            handleAttributeValueChange(
                              restrictIndex,
                              "role_id",
                              selectedOptions.map((option) => option.value)
                            )
                          }
                          placeholder={"Select Roles"}
                        />
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-6" key={restrictIndex}>
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("is_view")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <div className="form-check">
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={restrictField.is_view}
                              onChange={(e) =>
                                handleAttributeValueChange(
                                  restrictIndex,
                                  "is_view",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                            <label className="form-check-label pl-2">
                              {t("is_view")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-6" key={restrictIndex}>
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("is_edit")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <div className="form-check">
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={restrictField.is_edit}
                              onChange={(e) =>
                                handleAttributeValueChange(
                                  restrictIndex,
                                  "is_edit",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                            <label className="form-check-label pl-2">
                              {t("is_edit")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-2" key={restrictIndex}></div>
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  className="btn btn-block btn-secondary"
                  onClick={handleRestrictModalClose}
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  {t("close")}
                </button>
                <button
                  type="button"
                  onClick={handleRestrictModalClose}
                  className="btn btn-block btn-primary"
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  {t("save")}
                </button>
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={delModal}>
            <ModalHeader>{`Delete Attribute`}</ModalHeader>
            <ModalBody>
              <p
                className={`mb-0`}
              >{`Are you sure you want to delete this Attribute?`}</p>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isDelButtonLoad}
                onClick={onDeleteModalClose}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>

              {!isDelButtonLoad && (
                <button
                  type="button"
                  className="btn btn-block bg-red"
                  style={{ width: "100px" }}
                  onClick={onRemoveAttributeRow}
                >
                  {t("delete")} <i className="bi bi-trash3"></i>
                </button>
              )}
              {isDelButtonLoad && (
                <button
                  color="secondary"
                  type={`button`}
                  disabled={true}
                  className={`btn-square`}
                >
                  <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                  {`Loading...`}
                </button>
              )}
            </ModalFooter>
          </Modal>

          <Modal isOpen={delCheckModal}>
            <ModalHeader>{`Delete CheckList`}</ModalHeader>
            <ModalBody>
              <p
                className={`mb-0`}
              >{`Are you sure you want to delete this part checklist?`}</p>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isDelCheckButtonLoad}
                onClick={onDeleteCheckModalClose}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>

              {!isDelCheckButtonLoad && (
                <button
                  type="button"
                  className="btn btn-block bg-red"
                  style={{ width: "100px" }}
                  onClick={onRemoveCheckListRow}
                >
                  {t("delete")} <i className="bi bi-trash3"></i>
                </button>
              )}
              {isDelCheckButtonLoad && (
                <button
                  color="secondary"
                  type={`button`}
                  disabled={true}
                  className={`btn-square`}
                >
                  <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                  {`Loading...`}
                </button>
              )}
            </ModalFooter>
          </Modal>

          <Modal isOpen={delOptionModal}>
            <ModalHeader>{`Delete Option`}</ModalHeader>
            <ModalBody>
              <p
                className={`mb-0`}
              >{`Are you sure you want to delete this option?`}</p>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isDelOptionButtonLoad}
                onClick={onDeleteModalOptionClose}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>

              {!isDelOptionButtonLoad && (
                <button
                  type="button"
                  className="btn btn-block bg-red"
                  style={{ width: "100px" }}
                  onClick={onRemoveOptionRow}
                >
                  {t("delete")} <i className="bi bi-trash3"></i>
                </button>
              )}
              {isDelOptionButtonLoad && (
                <button
                  color="secondary"
                  type={`button`}
                  disabled={true}
                  className={`btn-square`}
                >
                  <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                  {`Loading...`}
                </button>
              )}
            </ModalFooter>
          </Modal>
        </div>
      </section>
    </div>
  );
};

export default AddCatalog;
